import {ATLAS_TMM_DB, REALTIME_DB} from '@/config/firebase';
import {push, ref, remove} from 'firebase/database';

export const getAllSystemWatchList = (airline: string) => {
  return ref(REALTIME_DB, `${airline}/${ATLAS_TMM_DB}/system_watch_list`);
};

export const addToSystemWatchList = async (airline: string, val: string) => {
  const item = ref(REALTIME_DB, `${airline}/${ATLAS_TMM_DB}/system_watch_list`);
  void push(item, val);
};

export const removeFromSystemWatchList = async (
  airline: string,
  key: string
) => {
  const item = ref(
    REALTIME_DB,
    `${airline}/${ATLAS_TMM_DB}/system_watch_list/${key}`
  );
  void remove(item);
};
